<template>
    <section class="section-padding">
        <div class="add-padding">
            <div class="row columns">
                <div class="col-md-6">
                    <img src="/images/valeur/valeur1.png" />
                </div>
                <div class="col-md-6 textValeur d-flex flex-column align-items-center justify-content-center">
                    <div class="container">
                        <h2 class="titre-section mb-20">
                            <span class="span-background-red">EMCI et ses valeurs</span>
                        </h2>
                        <p>
                            Nous partageons des valeurs fortes, et intervenons dans le respect du <a
                                href="https://www.codededeontologiedespsychologues.fr/Code-de-Deontologie-des.html"
                                target="_blank">Code de Déontologie</a> des
                            Psychologues.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script setup>
</script>
<style scoped>
.textValeur {
    background: #fff;
    box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    padding: 110px 80px;
}

.textValeur p {
    color: #25233E;
    /* txt */
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
}

.titre-section {
    text-align: left;
}

.titre-section span {
    color: #25233E;
    /* h2 */
    font-family: Nunito;
    font-size: 50px;
    font-style: normal;
    font-weight: 600;
    line-height: 111.5%;
    /* 61.325px */
    letter-spacing: -0.825px;
    text-transform: uppercase;
}

/* Styles pour les écrans de taille moyenne (M) */
@media only screen and (min-width: 100px) and (max-width: 768px) {
    .row img {
        padding-top: 5rem;
    }
}

@media only screen and (min-width: 769px) and (max-width: 991px) {
    .row img {
        padding-top: 3rem;
    }
}

@media only screen and (min-width: 1024px) and (max-width: 1440px) {
    .textValeur {
        padding: 40px 70px !important;
    }
}

@media only screen and (min-width: 1px) and (max-width: 1024px) {
    .row img {
        padding-top: 3rem;
    }
}

@media screen and (min-width: 320px) {}

@media screen and (min-width: 375px) {}

@media screen and (min-width: 425px) {}

@media screen and (min-width: 768px) {}

@media screen and (min-width: 1024px) {}

@media screen and (min-width: 1440px) {}

@media screen and (min-width: 2559px) {}
</style>